import React from 'react';
import { Tablet, Smartphone, Radar, Dna } from 'lucide-react';
const arsenalItems = [{
  id: 1,
  title: 'Protocolo de Blindaje',
  description: 'El manual de ingeniería conductual. No es teoría, son comandos directos para reescribir tu respuesta a los estímulos.',
  icon: <Tablet className="w-12 h-12 text-cyan-neon" data-id="element-13" />,
  mockupText: '[ MOCKUP IPAD ESCUDO ]',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/6yqoSMdfG2KiZFFe5YuDj9/Mockup_Producto_Principal_V4.png',
  reverse: false
}, {
  id: 2,
  title: 'Auxilio 60s',
  description: 'Tu extintor sónico para la urgencia. Un protocolo de audio de emergencia que corta el secuestro de la amígdala en menos de un minuto.',
  icon: <Smartphone className="w-12 h-12 text-cyan-neon" data-id="element-14" />,
  mockupText: '[ MOCKUP IPHONE CRONÓMETRO ROJO ]',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/pT5PttsU1ju1Cenf97SV2E/Mockup_Bonus_1.png',
  reverse: true
}, {
  id: 3,
  title: 'Restauración Seminal V10',
  description: 'Recuperación biológica de tu energía vital. Protocolos físicos y nutricionales para acelerar la regeneración de tus receptores de dopamina.',
  icon: <Dna className="w-12 h-12 text-cyan-neon" data-id="element-15" />,
  mockupText: '[ MOCKUP IPAD ADN ]',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/8nhqyrjaC4mAzzBFfzVRnF/Mockup_Bonus_2.png',
  reverse: true
}, {
  id: 4,
  title: 'Mapa de Disparadores',
  description: 'Inteligencia táctica para anticipar el ataque. Identifica tus zonas de peligro antes de que el impulso siquiera se forme.',
  icon: <Radar className="w-12 h-12 text-cyan-neon" data-id="element-16" />,
  mockupText: '[ MOCKUP IPAD RADAR ]',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/jG9LywT4SXrk9RgneSyssT/Mockup_Bonus_3.png',
  reverse: false
}];
export function ArsenalSection() {
  return <section className="py-14 px-4 bg-deep-black border-t border-card-border" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <div className="text-center mb-20" data-id="element-19">
          <h2 className="font-bebas text-4xl md:text-6xl text-white mb-4" data-id="element-20">
            EL ARSENAL <span className="text-cyan-neon" data-id="element-21">TÁCTICO</span>
          </h2>
          <p className="font-inter text-lg text-text-muted max-w-2xl mx-auto" data-id="element-22">
            Herramientas de precisión militar diseñadas para desmantelar el
            hábito desde la raíz neurológica.
          </p>
        </div>

        <div className="space-y-14" data-id="element-23">
          {/* Main Product */}
          {arsenalItems.filter(item => item.id === 1).map(item => <div key={item.id} className={`flex flex-col ${item.reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-center gap-12`} data-id="element-24">
                <div className="w-full lg:w-3/5" data-id="element-25">
                  <div className={`${item.imageUrl ? '' : 'aspect-[4/3]'} bg-card-dark border border-card-border rounded-2xl flex flex-col items-center justify-center relative overflow-hidden group ${item.imageUrl ? '' : 'p-8'}`} data-id="element-26">
                    {item.imageUrl ? <img src={item.imageUrl} alt={item.title} className="w-full h-auto rounded-2xl" data-id="element-27" /> : <>
                        <div className="absolute inset-0 bg-gradient-to-t from-cyan-neon/5 to-transparent opacity-50" data-id="element-28"></div>
                        {item.icon}
                        <span className="font-bebas text-2xl tracking-widest text-text-muted mt-6 group-hover:text-white transition-colors" data-id="element-29">
                          {item.mockupText}
                        </span>
                      </>}
                  </div>
                </div>

                <div className="w-full lg:w-2/5 flex flex-col justify-center" data-id="element-30">
                  <div className="flex items-center gap-4 mb-4" data-id="element-31">
                    <span className="font-bebas text-6xl text-card-border font-bold" data-id="element-32">
                      0{item.id}
                    </span>
                    <h3 className="font-bebas text-3xl md:text-4xl text-white tracking-wide" data-id="element-33">
                      {item.title}
                    </h3>
                  </div>
                  <p className="font-inter text-lg text-text-muted leading-relaxed pl-16 lg:pl-0" data-id="element-34">
                    {item.description}
                  </p>
                </div>
              </div>)}

          {/* Bonus Title */}
          <div className="text-center" data-id="element-35">
            <h3 className="font-bebas text-3xl md:text-5xl text-white mb-2" data-id="element-36">
              🎁 <span className="text-cyan-neon" data-id="element-37">3 BONUS EXCLUSIVOS</span>{' '}
              INCLUIDOS
            </h3>
            <p className="font-inter text-lg text-text-muted max-w-2xl mx-auto" data-id="element-38">
              Además del Protocolo de Blindaje, recibes estas 3 herramientas
              tácticas de refuerzo.
            </p>
          </div>

          {/* Bonus #1: Icon left, description right */}
          <div className="flex flex-row items-start gap-8" data-id="element-39">
            <div className="shrink-0 flex flex-col items-center" data-id="element-40">
              <span className="font-bebas text-lg text-cyan-neon tracking-wider mb-3" data-id="element-41">
                BONUS #1
              </span>
              <img src="https://cdn.magicpatterns.com/uploads/pT5PttsU1ju1Cenf97SV2E/Mockup_Bonus_1.png" alt="Auxilio 60s" className="w-28 h-28 md:w-36 md:h-36 object-contain rounded-xl" data-id="element-42" />
            </div>
            <div className="flex flex-col justify-center" data-id="element-43">
              <h3 className="font-bebas text-3xl md:text-4xl text-white tracking-wide mb-3" data-id="element-44">
                Auxilio 60s
              </h3>
              <p className="font-inter text-text-muted text-[14px]" data-id="element-45">
                Instrucciones paso a paso para cortar el impulso en menos de 1
                minuto.
              </p>
            </div>
          </div>

          {/* Bonus #2: Icon left, description right */}
          <div className="flex flex-row items-start gap-8" data-id="element-46">
            <div className="shrink-0 flex flex-col items-center" data-id="element-47">
              <span className="font-bebas text-lg text-cyan-neon tracking-wider mb-3" data-id="element-48">
                BONUS #2
              </span>
              <img src="https://cdn.magicpatterns.com/uploads/8nhqyrjaC4mAzzBFfzVRnF/Mockup_Bonus_2.png" alt="Restauración Seminal V10" className="w-28 h-28 md:w-36 md:h-36 object-contain rounded-xl" data-id="element-49" />
            </div>
            <div className="flex flex-col justify-center" data-id="element-50">
              <h3 className="font-bebas text-3xl md:text-4xl text-white tracking-wide mb-3" data-id="element-51">
                Restauración Seminal V10
              </h3>
              <p className="font-inter text-text-muted text-[14px]" data-id="element-52">
                Recupera tu energía vital. Protocolos físicos y nutricionales
                para regenerar tu dopamina.
              </p>
            </div>
          </div>

          {/* Bonus #3: Icon left, description right */}
          <div className="flex flex-row items-start gap-8" data-id="element-53">
            <div className="shrink-0 flex flex-col items-center" data-id="element-54">
              <span className="font-bebas text-lg text-cyan-neon tracking-wider mb-3" data-id="element-55">
                BONUS #3
              </span>
              <img src="https://cdn.magicpatterns.com/uploads/jG9LywT4SXrk9RgneSyssT/Mockup_Bonus_3.png" alt="Mapa de Disparadores" className="w-28 h-28 md:w-36 md:h-36 object-contain rounded-xl" data-id="element-56" />
            </div>
            <div className="flex flex-col justify-center" data-id="element-57">
              <h3 className="font-bebas text-3xl md:text-4xl text-white tracking-wide mb-3" data-id="element-58">
                Mapa de Disparadores
              </h3>
              <p className="font-inter text-text-muted text-[14px]" data-id="element-59">
                Inteligencia táctica para anticipar el ataque. Identifica tus
                zonas de peligro antes de que el impulso siquiera se forme.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}